import React from 'react'
import { Route, Routes } from 'react-router-dom'
import {
  Membership,
  MembershipBenefitsUsage,
  MembershipMemberDetail,
} from '@components/pages/Membership'

function MembershipPage(): React.ReactElement {
  return (
    <Routes>
      <Route index element={<Membership />} />
      <Route path=":memberId/benefits" element={<MembershipBenefitsUsage />} />
      <Route path=":memberId" element={<MembershipMemberDetail />} />
    </Routes>
  )
}

export default MembershipPage
